
$(document).ready(function(){
  $('.roll_div').slick({
    dots: true,
    lazyLoad: 'ondemand',
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    autoplay: true,
    autoplaySpeed: 5000,
    cssEase: 'ease-in-out',
    prevArrow: false,
    nextArrow: false,
    useTransform: false,
    accessibility: false,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },

    ],
  });


  
  let mp = document.getElementsByClassName("mp-item");
  Array.prototype.forEach.call(mp, function(el) {
    el.classList.remove("invisible");
	});
  
  let test = document.getElementsByClassName("testimony");
  Array.prototype.forEach.call(test, function(el){
    el.classList.remove("invisible");
  });                         
  
});


function swapToOgImage(imgElement) {
  const fullSrc = imgElement.getAttribute('data-second-full-src');
  const ogSrc = imgElement.getAttribute('data-og-src');
  if (!fullSrc.includes( 'no-image')){

  imgElement.src = ogSrc;
}
}
function loadFullImage(imgElement) {
  const preSrc = imgElement.getAttribute('data-second-src');
  const fullSrc = imgElement.getAttribute('data-second-full-src');
  if (fullSrc === null) {
    return;
  }
  if (!fullSrc.includes( 'no-image')){

  const fullImage = new Image();
  imgElement.setAttribute('data-og-src', imgElement.getAttribute('src'));
  imgElement.style.imageRendering = 'pixelated';
  imgElement.src = preSrc;

  fullImage.src = fullSrc;
  fullImage.onload = function() {
    imgElement.style.imageRendering = 'auto';
    imgElement.src = fullSrc;
  };
}
}



function parseResponseData(response) {
  const parsedData = response.map(item => ({
      title: item.title,
      inventoryQuantity: parseInt(item.inventoryQuantity, 10),
      price: parseFloat(item.price),
      descriptionHtml: item.descriptionHtml,
      onlineStoreUrl: item.onlineStoreUrl,
      imageUrl: item.url,
      otherImages: item.otherImages || [],
      tags: item.tags || [],
  }));

  return parsedData;
}

function getRandomInt(max) {
return Math.floor(Math.random() * max);
}

function imageOnHover(imgElement) { 
  const secondSrc = imgElement.getAttribute('data-second-src');
  const ogSrc = imgElement.getAttribute('data-og-src');
  const currentSrc = imgElement.getAttribute('src');
  if (currentSrc === ogSrc) {
    imgElement.src = secondSrc;
  } else {
    imgElement.src = ogSrc;
  }

}

  function extractSpecsFromTags(tags) {
      const specs = {
        maxCores: null,
        maxRam: null,
        maxStorage: null
      };
      
      if (!tags || !Array.isArray(tags)) return specs;
      
      tags.forEach(tag => {
        if (tag.startsWith('max-cores=')) {
          specs.maxCores = tag.split('=')[1];
        } else if (tag.startsWith('max-ram=')) {
          specs.maxRam = tag.split('=')[1];
        } else if (tag.startsWith('max-storage=')) {
          specs.maxStorage = tag.split('=')[1];
        }
      });
      
      return specs;
  }
  function formatStorage(storage) {
      if (!storage) return '';
      
      const storageNum = parseInt(storage, 10);
      if (isNaN(storageNum)) return storage;
      
      if (storageNum >= 1000) {
        return (storageNum / 1000).toFixed(1) + 'TB';
      }
      
      return storage + 'GB';
  }

function replaceProductCards(products) {

  let usedIndices = new Set(); 

  const getNextValidProduct = (products, startIndex) => {
    for (let i = startIndex; i < products.length; i++) {
      if (products[i] && products[i].title && !usedIndices.has(i)) {
        usedIndices.add(i); // Mark this index as used
        return products[i];
      }
    }
    return null;
  };


    function createSpecElements(specs, specContainer) {
      specContainer.innerHTML = ''; // Clear existing specs
      if (!specs || Object.keys(specs).length === 0) return;

      function formatRam(ram) {
        if (!ram) return '';
        const ramNum = parseInt(ram, 10);
        if (isNaN(ramNum)) return ram;
        if (ramNum >= 1000) {
          return (ramNum / 1000).toFixed(1) + 'TB';
        }
        return ram + 'GB';
      }
      function formatStorage(storage) {
        if (!storage) return '';
        const storageNum = parseInt(storage, 10);
        if (isNaN(storageNum)) return storage;
        if (storageNum >= 1000) {
          return (storageNum / 1000).toFixed(1) + 'TB';
        }
        return storage + 'GB';
      }

      const specHtml = `
        <div class="server-product-specs">
          <div class="server-product-spec">
            <svg class="spec-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect>
              <rect x="9" y="9" width="6" height="6"></rect>
            </svg>
            <span class="spec-value">Up to ${specs.maxCores ? specs.maxCores : '-'} Cores</span>
          </div>
          <div class="server-product-spec">
            <svg class="spec-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M6 19h12V5H6v14zm6-7a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"></path>
            </svg>
            <span class="spec-value">Up to ${specs.maxRam ? formatRam(specs.maxRam) : '-'} RAM</span>
          </div>
          <div class="server-product-spec">
            <svg class="spec-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 12H2m20-4H2m20-4H2M2 20h20M2 16h20"></path>
            </svg>
            <span class="spec-value">Up to ${specs.maxStorage ? formatStorage(specs.maxStorage) : '-'} Storage</span>
          </div>
        </div>
      `;
      specContainer.innerHTML = specHtml;
    }



  const updateProductCard = (imgEl, titleEl, priceEl, containerEl, specContainer, warrElId, product, fallbackIndex) => {


    if (!product || !product.title) {
      product = getNextValidProduct(products, fallbackIndex);
    }

    let specs= {};

    if (product && product.tags) {
     specs = extractSpecsFromTags(product.tags);
    }

    if (product) {
      imgEl.src = product['imageUrl'] || '';
      imgEl.setAttribute('data-og-src', imgEl.src);
      imgEl.setAttribute('data-second-src', product['otherImages'][product['otherImages'].length - 1].url || '');
      imgEl.setAttribute('data-second-full-src', product['otherImages'][product['otherImages'].length - 1].url || '');
      imgEl.setAttribute('onmouseover', `imageOnHover(this)`);
      imgEl.setAttribute('onmouseout', `swapToOgImage(this)`);
      titleEl.innerHTML = product['title']; 
      priceEl.innerHTML = '$' + (parseFloat(product['price']) || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      // createSpecElements(specs, specContainer);
      containerEl.setAttribute('onclick', `logAndRedirect("${product['onlineStoreUrl'] || '#'}", "trending", "${product['title'] ? product['title'].replace('"', '') : ''}")`);
      if (product['title'] && product['title'].includes('Dell Certified Refurbished')) {
        document.getElementById(warrElId).style.display = 'none';
      }
    }
  };

  if (products.length > 0) {
    const productEls = [
      {
        img: document.getElementById('firstTrendingImage'),
        title: document.getElementById('firstTrendingTitle'),
        price: document.getElementById('firstTrendingPrice'),
        container: document.getElementById('firstTrendingContainer'),
        specContainer: document.getElementById('firstTrendingContainer').querySelector('.specContainer'),
        warrId: 'firstWarr',
        fallback: 1
      },
      {
        img: document.getElementById('secondTrendingImage'),
        title: document.getElementById('secondTrendingTitle'),
        price: document.getElementById('secondTrendingPrice'),
        container: document.getElementById('secondTrendingContainer'),
        specContainer: document.getElementById('secondTrendingContainer').querySelector('.specContainer'),
        warrId: 'secondWarr',
        fallback: 2
      },
      {
        img: document.getElementById('thirdTrendingImage'),
        title: document.getElementById('thirdTrendingTitle'),
        price: document.getElementById('thirdTrendingPrice'),
        container: document.getElementById('thirdTrendingContainer'),
        specContainer: document.getElementById('thirdTrendingContainer').querySelector('.specContainer'),
        warrId: 'thirdWarr',
        fallback: 3
      },
      {
        img: document.getElementById('fourthTrendingImage'),
        title: document.getElementById('fourthTrendingTitle'),
        price: document.getElementById('fourthTrendingPrice'),
        container: document.getElementById('fourthTrendingContainer'),
        specContainer: document.getElementById('fourthTrendingContainer').querySelector('.specContainer'),
        warrId: 'fourthWarr',
        fallback: 4
      },
      {
        img: document.getElementById('fifthTrendingImage'),
        title: document.getElementById('fifthTrendingTitle'),
        price: document.getElementById('fifthTrendingPrice'),
        container: document.getElementById('fifthTrendingContainer'),
        specContainer: document.getElementById('fifthTrendingContainer').querySelector('.specContainer'),
        warrId: 'fifthWarr',
        fallback: 5
      }
    ];

    productEls.forEach((el, index) => {
      const product = products[index] && !usedIndices.has(index) ? products[index] : null;
      usedIndices.add(index); // Mark product as used
      updateProductCard(el.img, el.title, el.price, el.container, el.specContainer, el.warrId, product, el.fallback);
    });

    document.querySelectorAll('#SkeletonPlaceholder').forEach(el => el.classList.remove('skeleton_text'));
    document.querySelectorAll('.loading-skeleton').forEach(el => el.classList.remove('loading-skeleton'));
  }
}


async function getPurchasedTogether(sku) {
  const url = `http://apiapi.ombligo.com/getTrending`;

  try {
      const response = await fetch(url);
      if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      const parsedData = JSON.parse(data);

      replaceProductCards(parseResponseData(parsedData));
      return parsedData;
  } catch (error) {
      console.error('Error fetching data: ', error);
  }
}


function getRandomInt(max) {
  return Math.floor(Math.random() * max);
}

function replaceProductTypeCards(type, products) {

    typeMap = {
      'ECC Reg Memory': 'mem',
      'Server Processors': 'proc',
      'Solid State Hard Drive': 'drive'
    
    }
    type = typeMap[type];
    if (type === 'mem' || type === 'proc' ) return; // Skip these types for now

    var firstIMG = document.getElementById(type + 'firstTrendingImage');
    var firstTitle = document.getElementById(type + 'firstTrendingTitle');
    var firstPrice = document.getElementById(type + 'firstTrendingPrice');
    var firstContainer = document.getElementById(type + 'firstTrendingContainer');

    
    var secondIMG = document.getElementById(type + 'secondTrendingImage');
    var secondTitle = document.getElementById(type + 'secondTrendingTitle');
    var secondPrice = document.getElementById(type + 'secondTrendingPrice');
    var secondContainer = document.getElementById(type + 'secondTrendingContainer');

    
    var thirdIMG = document.getElementById(type + 'thirdTrendingImage');
    var thirdTitle = document.getElementById(type + 'thirdTrendingTitle');
    var thirdPrice = document.getElementById(type + 'thirdTrendingPrice');
    var thirdContainer = document.getElementById(type + 'thirdTrendingContainer');

    
    var fourthIMG = document.getElementById(type + 'fourthTrendingImage');
    var fourthTitle = document.getElementById(type + 'fourthTrendingTitle');
    var fourthPrice = document.getElementById(type + 'fourthTrendingPrice');
    var fourthContainer = document.getElementById(type + 'fourthTrendingContainer');


    var SkeletonPlaceholder =  Array.from(document.querySelectorAll('#SkeletonPlaceholder'));

    if (products.length > 0) {
        p1 = products[0];
        p2 = products[1];
        p3 = products[2];
        p4 = products[3];
        p5 = products[4];


        try{
          firstIMG.src = p1['imageUrl'];
          firstTitle.innerHTML = p1['title'];
          firstPrice.innerHTML = '$' + p1['price'].toFixed(2);
          firstContainer.setAttribute('onclick', 'logAndRedirect("' + p1['onlineStoreUrl'] + '", "trending-'+ type + '", "' + p1['title'].replace('"','') +'")');
        }
        catch(err){
         // console.log(err);
        }
       // firstContainer.classList.remove('loading-skeleton');
       // firstTextContainer.classList.remove('loading-skeleton');
        try{
          secondIMG.src = p2['imageUrl'];
          secondTitle.innerHTML = p2['title'];
          secondPrice.innerHTML = '$' + p2['price'].toFixed(2);
          secondContainer.setAttribute('onclick', 'logAndRedirect("' + p2['onlineStoreUrl'] + '", "trending-'+ type + '", "' + p2['title'].replace('"','') +'")');
       }
        catch(err){
         // console.log(err);
        }

        try{
        thirdIMG.src = p3['imageUrl'];
        thirdTitle.innerHTML = p3['title'];
        thirdPrice.innerHTML = '$' + p3['price'].toFixed(2);
        thirdContainer.setAttribute('onclick', 'logAndRedirect("' + p3['onlineStoreUrl'] + '", "trending-'+ type + '", "' + p3['title'].replace('"','') +'")');
        }
        catch(err){
         // console.log(err);
        }
       // thirdContainer.classList.remove('loading-skeleton');
       // thirdTextContainer.classList.remove('loading-skeleton');
        try{
        fourthIMG.src = p4['imageUrl'];
        fourthTitle.innerHTML = p4['title'];
        fourthPrice.innerHTML = '$' + p4['price'].toFixed(2);
        fourthContainer.setAttribute('onclick', 'logAndRedirect("' + p4['onlineStoreUrl'] + '", "trending-'+ type + '", "' + p4['title'].replace('"','') +'")');
}
        catch(err){
         // console.log(err);
        }
        // thirdContainer.classList.remove('loading-skeleton');



        document.querySelectorAll('#SkeletonPlaceholder').forEach(el => el.classList.remove('skeleton_text'));
        document.querySelectorAll('.loading-skeleton').forEach(el => el.classList.remove('loading-skeleton'));

    }




}



async function getTrendingProductTypes(sku) {
    const url = `https://apiapi.ombligo.com/getTrendingProducts`;

    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        const parsedData = JSON.parse(data);
        presentedData = {};
        for (item in parsedData){
            if (presentedData[item] == undefined){

              replaceProductTypeCards(item, parseResponseData(parsedData[item]));
              presentedData[item] = parseResponseData(parsedData[item]);
            }
        }
        
        //replaceProductCards(parseResponseData(parsedData));
        return parsedData;
    } catch (error) {
        console.log('Likely No data to pull ', error);
    }
}




async function replaceProductTypeCardsNew(type, products, categoryType) {
  // Map consumer types to 'mem' elements and upgrade types to 'proc' elements
  let elementType;
  if (categoryType === 'consumer') {
    elementType = 'mem';
  } else if (categoryType === 'upgrade') {
    elementType = 'proc';
  } else {
    const typeMap = {
      'ECC Reg Memory': 'mem',
      'Server Processors': 'proc',
      'Solid State Hard Drive': 'drive'
    };
    elementType = typeMap[type];
    if (elementType === 'mem' || elementType === 'proc') return; // Skip these types for now
  }



  var firstIMG = document.getElementById(elementType + 'firstTrendingImage');
  var firstTitle = document.getElementById(elementType + 'firstTrendingTitle');
  var firstPrice = document.getElementById(elementType + 'firstTrendingPrice');
  var firstContainer = document.getElementById(elementType + 'firstTrendingContainer');

  var secondIMG = document.getElementById(elementType + 'secondTrendingImage');
  var secondTitle = document.getElementById(elementType + 'secondTrendingTitle');
  var secondPrice = document.getElementById(elementType + 'secondTrendingPrice');
  var secondContainer = document.getElementById(elementType + 'secondTrendingContainer');

  var thirdIMG = document.getElementById(elementType + 'thirdTrendingImage');
  var thirdTitle = document.getElementById(elementType + 'thirdTrendingTitle');
  var thirdPrice = document.getElementById(elementType + 'thirdTrendingPrice');
  var thirdContainer = document.getElementById(elementType + 'thirdTrendingContainer');

  var fourthIMG = document.getElementById(elementType + 'fourthTrendingImage');
  var fourthTitle = document.getElementById(elementType + 'fourthTrendingTitle');
  var fourthPrice = document.getElementById(elementType + 'fourthTrendingPrice');
  var fourthContainer = document.getElementById(elementType + 'fourthTrendingContainer');

  var SkeletonPlaceholder = Array.from(document.querySelectorAll('#SkeletonPlaceholder'));

  if (products.length > 0) {
    p1 = products[0];
    p2 = products[1];
    p3 = products[2];
    p4 = products[4];
    p5 = products[4];

    let imageTest = new Image();



    try {
      firstIMG.src = p1['imageUrl'];
      firstTitle.innerHTML = p1['title'];
      firstPrice.innerHTML = '$' + p1['price'].toFixed(2);
      firstContainer.setAttribute('onclick', 'logAndRedirect("' + p1['onlineStoreUrl'] + '", "trending-' + elementType + '", "' + p1['title'].replace('"', '') + '")');

      } catch (err) {

      }

    try {
      secondIMG.src = p2['imageUrl'];
      secondTitle.innerHTML = p2['title'];
      secondPrice.innerHTML = '$' + p2['price'].toFixed(2);
      secondContainer.setAttribute('onclick', 'logAndRedirect("' + p2['onlineStoreUrl'] + '", "trending-' + elementType + '", "' + p2['title'].replace('"', '') + '")');


    } catch (err) {

    }

    try {
      thirdIMG.src = p3['imageUrl'];
      thirdTitle.innerHTML = p3['title'];
      thirdPrice.innerHTML = '$' + p3['price'].toFixed(2);
      thirdContainer.setAttribute('onclick', 'logAndRedirect("' + p3['onlineStoreUrl'] + '", "trending-' + elementType + '", "' + p3['title'].replace('"', '') + '")');

    } catch (err) {

      
    }

    try {

      fourthIMG.src = p4['imageUrl'];
      fourthTitle.innerHTML = p4['title'];
      fourthPrice.innerHTML = '$' + p4['price'].toFixed(2);
      fourthContainer.setAttribute('onclick', 'logAndRedirect("' + p4['onlineStoreUrl'] + '", "trending-' + elementType + '", "' + p4['title'].replace('"', '') + '")');

    } catch (err) {

      
    }

    document.querySelectorAll('#SkeletonPlaceholder').forEach(el => el.classList.remove('skeleton_text'));
    document.querySelectorAll('.loading-skeleton').forEach(el => el.classList.remove('loading-skeleton'));
  }
}

async function getTrendingProductTypesNew() {
  const url = `https://apiapi.ombligo.com/getTrendingProductsNew`;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    const parsedData = JSON.parse(data);

    if (parsedData.consumerTypes) {
      let allConsumerProducts = [];
      for (const productType in parsedData.consumerTypes) {
        const products = parseResponseData(parsedData.consumerTypes[productType]);
        allConsumerProducts = allConsumerProducts.concat(products);
      }
      await replaceProductTypeCardsNew('consumer', allConsumerProducts, 'consumer');
    }
    
    if (parsedData.upgradeTypes) {
      let allUpgradeProducts = [];
      for (const productType in parsedData.upgradeTypes) {
        const products = parseResponseData(parsedData.upgradeTypes[productType]);
        allUpgradeProducts = allUpgradeProducts.concat(products);
      }
      await replaceProductTypeCardsNew('upgrade', allUpgradeProducts, 'upgrade');
    }
    
    if (!parsedData.consumerTypes && !parsedData.upgradeTypes) {
      presentedData = {};
      for (const item in parsedData) {
        if (presentedData[item] == undefined) {
          await replaceProductTypeCardsNew(item, parseResponseData(parsedData[item]));
          presentedData[item] = parseResponseData(parsedData[item]);
        }
      }
    }
    
    return parsedData;
  } catch (error) {
    console.log('Likely No data to pull ', error);
  }
}





const dots = document.querySelectorAll('.dot');
let blinkInterval;

function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

function blinkDot(dot) {
    const opacity = getRandomInt(0, 1);
    dot.style.opacity = opacity;
}

function blinkDotsRandomly() {
    dots.forEach(dot => {
        setTimeout(() => {
            blinkDot(dot);
            setTimeout(() => {
                dot.style.opacity = 1;
            }, 750);
        }, getRandomInt(1000, 3000));
    });
}


function blinkLogRedirect() {
    blinkInterval = setInterval(blinkDotsRandomly, 150); 
    setTimeout(() => {
        dots.forEach(dot => dot.style.opacity = 1);  
        logAndRedirect('CTO', 'home', 'https://techmikeny.com/configure-to-order-servers');
    }, 200);
}

setInterval(() => {
    blinkDotsRandomly();
    setTimeout(() => {
        clearInterval(blinkInterval);
        dots.forEach(dot => dot.style.opacity = 1);
    }, 1000);
}, getRandomInt(5000, 30000));


document.addEventListener('keydown', function(event) {

  if ((event.ctrlKey || event.metaKey) && event.key === 'b') {
        event.preventDefault(); // Prevent default browser behavior  
        blinkLogRedirect();
    }
});